<template>
  <div>
    <div v-if="!selectedFeeSetting">
      <a-spin :spinning="loading">
        <p class="font-weight-bold mb-2">Generated Fees Details:</p>
        <hr class="mt-0">
        <div>
          <p class="text-muted mb-2">One time Fees</p>
          <vue-custom-scrollbar class="scroll-area">
            <table class="table table-borderless">
              <thead class="bg-light">
                <tr>
                  <th>Fees</th>
                  <th>Amount</th>
                  <th>Start Date</th>
                  <th>Due Date</th>
                  <th>End Date</th>
                  <th>Fine (₹)</th>
                  <th>Discount Amt. (₹)</th>
                  <th>Discount (%)</th>
                  <th class="text-right">Actions</th>
                </tr>
              </thead>
              <tbody v-if="getOneTimeFeeSettings(data).length">
                <tr v-for="feeSetting in getOneTimeFeeSettings(data)" :key="feeSetting.id">
                  <th>{{ feeSetting.class_fee.fee.name }}</th>
                  <td class="font-weight-bold">₹ {{ feeSetting.fee_amount }}</td>
                  <td class="text-primary">{{ moment(feeSetting.start_date).format(dateFormat) }}</td>
                  <td class="text-primary">{{ feeSetting.due_date ? moment(feeSetting.due_date).format(dateFormat): null}}</td>
                  <td class="text-danger">{{ moment(feeSetting.end_date).format(dateFormat) }}</td>
                  <td class="font-weight-bold">{{ feeSetting.fine_amount }}</td>
                  <td class="font-weight-bold">{{ feeSetting.discount_amount }}</td>
                  <td class="font-weight-bold">{{ feeSetting.discount_percentage }}</td>
                  <td class="text-right">
                    <template v-if="!feeSetting.status">
                      <span class="text-muted mr-2">Generating</span><a-spin size="small"/>
                    </template>
                    <template v-else>
                      <a
                        href="javascript:;"
                        :class="['p-1 mr-2 text-primary neo-icon-btn']"
                        @click="showPaymentStatus(feeSetting)"
                      >
                        <i class="fe fe-eye" />
                      </a>
                      <a
                        href="javascript:;"
                        :class="['p-1 mr-2 text-dark neo-icon-btn']"
                        @click="showEditModal(feeSetting)"
                      >
                        <i class="fe fe-edit" />
                      </a>
                      <a
                        href="javascript:;"
                        :class="['p-1 mr-2 text-dark neo-icon-btn']"
                        @click="regenerate(feeSetting.id)"
                      >
                        <i class="fe fe-refresh-cw" />
                      </a>
                      <a
                        href="javascript:;"
                        :class="['p-1 text-danger neo-icon-btn']"
                        @click="onDelete(feeSetting.id)"
                      >
                        <i class="fe fe-trash" />
                      </a>
                    </template>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="2" class="pt-3">
                    <a-tag color="orange">No fees have been generate yet!</a-tag>
                  </td>
                </tr>
              </tbody>
            </table>
          </vue-custom-scrollbar>
        </div>

        <!-- Recurring -->
        <div class="mt-3">
          <p class="text-muted mb-2">Recurring Fees</p>
          <vue-custom-scrollbar class="scroll-area">
            <table class="table table-borderless">
              <thead class="bg-light">
                <tr>
                  <th>Fees</th>
                  <th>Amount (₹)</th>
                  <th>Type</th>
                  <th>Start Date</th>
                  <th>Due Date</th>
                  <th>End Date</th>
                  <th>Fine (₹)</th>
                  <th>Discount Amt. (₹)</th>
                  <th>Discount (%)</th>
                  <th class="text-right">Actions</th>
                </tr>
              </thead>
              <tbody v-if="getRecurringFeeSettings(data).length">
                <tr
                  v-for="feeSetting in getRecurringFeeSettings(data)"
                  :key="feeSetting.id"
                >
                  <th>{{ feeSetting.class_fee.fee.name }}</th>
                  <td class="font-weight-bold">₹ {{ feeSetting.fee_amount }}</td>
                  <td class="font-weight-bold">{{ getFeeType(feeSetting.type) }}</td>
                  <td class="text-primary">{{ moment(feeSetting.start_date).format(dateFormat) }}</td>
                  <td class="text-primary">{{ feeSetting.due_date ? moment(feeSetting.due_date).format(dateFormat): null}}</td>
                  <td class="text-danger">{{ moment(feeSetting.end_date).format(dateFormat) }}</td>
                  <td class="font-weight-bold">{{ feeSetting.fine_amount }}</td>
                  <td class="font-weight-bold">{{ feeSetting.discount_amount }}</td>
                  <td class="font-weight-bold">{{ feeSetting.discount_percentage }}</td>
                  <td class="text-right">
                    <template v-if="!feeSetting.status">
                      <span class="text-muted mr-2">Generating</span><a-spin size="small"/>
                    </template>
                    <template v-else>
                      <a
                        href="javascript:;"
                        :class="['p-1 mr-2 text-primary neo-icon-btn']"
                        @click="showPaymentStatus(feeSetting)"
                      >
                        <i class="fe fe-eye" />
                      </a>
                      <a
                        href="javascript:;"
                        :class="['p-1 mr-2 text-dark neo-icon-btn']"
                        @click="showEditModal(feeSetting)"
                      >
                        <i class="fe fe-edit" />
                      </a>
                      <a
                        href="javascript:;"
                        :class="['p-1 mr-2 text-dark neo-icon-btn']"
                        @click="regenerate(feeSetting.id)"
                      >
                        <i class="fe fe-refresh-cw" />
                      </a>
                      <a
                        href="javascript:;"
                        :class="['p-1 text-danger neo-icon-btn']"
                        @click="onDelete(feeSetting.id)"
                      >
                        <i class="fe fe-trash" />
                      </a>
                    </template>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="2" class="pt-3">
                    <a-tag color="orange">No recurring fees have been generate yet!</a-tag>
                  </td>
                </tr>
              </tbody>
            </table>
          </vue-custom-scrollbar>
        </div>
      </a-spin>
    </div>
    <div v-else>
      <div>
        <div class="row align-items-center">
          <div class="col-md-10">
            <p class="mb-0 font-weight-bold">
              {{selectedFeeSetting.class_fee.fee.name}}
              (<span class="text-success">{{moment(selectedFeeSetting.start_date).format('ll')}}</span> -
              <span class="text-danger">{{moment(selectedFeeSetting.end_date).format('ll')}}</span>)
            </p>
          </div>
          <div class="col-md-2 text-right">
            <button class="btn btn-sm btn-dark" @click="selectedFeeSetting = undefined">
              Back
            </button>
          </div>
        </div>
        <hr class="mt-2">
        <PaymentStatusTable :feeSetting="selectedFeeSetting" :classId="classId" :sessionId="sessionId"/>
      </div>
    </div>

    <edit-generate-fee :classId="classId" :sessionId="sessionId" @edited="handleEdited"/>
  </div>
</template>
<script>
import moment from 'moment'

import EditGenerateFee from '@/components/feemanagement/manage/Forms/Edit/index'
import PaymentStatusTable from '@/components/feemanagement/manage/Table/PaymentStatus/index'

import vueCustomScrollbar from 'vue-custom-scrollbar'

import { feeTypes } from '@/services/globaldata'
import { find } from 'lodash'

export default {

  name: 'FeesTable',
  components: {
    EditGenerateFee,
    PaymentStatusTable,
    vueCustomScrollbar,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    classId: Number,
    sessionId: Number,
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
      feeTypes,
      dateFormat: 'DD-MM-YYYY',
      selectedFeeSetting: undefined,
    }
  },
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  watch: {
    data: function(value) {
      this.selectedFeeSetting = undefined
    },
  },
  methods: {
    moment,
    find,
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    showPaymentStatus(feeSettingId) {
      this.selectedFeeSetting = feeSettingId
    },
    showEditModal: function(feeSetting) {
      this.$eventBus.$emit('openGenerateFeeSettingsEditModal', feeSetting)
    },
    handleEdited: function () {
      this.$emit('updateTable')
    },
    regenerate: function (feeSettingId) {
      this.$confirm({
        title: 'Are you sure to re-generate this already generated fee?',
        content: `Please be cautious that you are going to generate the fee again. Click Yes to re-regenerate the selected fee.`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .post('/api/fee_setting/regenerate/' + feeSettingId)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Regenerate Successfully!',
                description: 'Fee setting has been re-generated',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
    onDelete: function(feeSettingId) {
      this.$confirm({
        title: 'Are you sure?',
        content: `Generated fees will be deleted if you click Yes`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/fee_setting/' + feeSettingId)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: 'Fee setting has been deleted with all generated fees.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
    getOneTimeFeeSettings(data) {
      const oneTime = data.filter(element => element.type === 1)
      return oneTime
    },
    getRecurringFeeSettings(data) {
      const recurring = data.filter(element => element.type !== 1)
      return recurring
    },
    getFeeType(type) {
      return find(this.feeTypes, { value: type }).name
    },
  },
}
</script>
